import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { InputLabel } from "@mui/material";
import { baseURL } from "../../Config/config";
import { Link } from "@mui/material";
import Modal from "@mui/material/Modal";
import { Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Projectcolors from "../../Utils/Colors";
// import GlobalLoader from "./CommonC/GlobalLoader";
import Header from "../CommonC/Header";

// import bg from "../images/AI.jpg";
import Selexlogo from "../../images/SelexSuite copy.png";
import optimizelogo from "../../images/SelexSuite copy.png";
import first from "../../images/1.png";
import second from "../../images/2.png";
import third from "../../images/3.png";
import fourth from "../../images/4.png";
// import BackgroundContainer from "./CommonC/BackgroundContainer";
import SubNavbar from "../CommonC/SubNavbar";
import { Alert } from "@mui/material";
import BgContainer2 from "../CommonC/BgContainer2";
import Selexrisk from "../../images/SelexRiskFinal.png";

import selexmathimg from "../../images/SelexSIM.png";
import selexsuite from "../../images/SelexSuite copy.png";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AdminNavbar from "../CommonC/AdminNavbar";




const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 700,
  bgcolor: "white",
  border: "2px solid #000",
  p: 4,
  overflow: "scroll",
  display: "block",
};
const stylec = {
  position: "absolute",
  top: "48%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 480,
  bgcolor: "white",
  border: "2px solid #000",
  p: 4,
  display: "block",
};
const Admin = ({ checkAdminRole }) => {
  const navigate = useNavigate();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openc, setOpenc] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({
    isOpen: false,
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal, isOpen } = state;

  const handleOpenc = () => setOpenc(true);
  const handleClosec = () => setOpenc(false);

  const handleAuth = async () => {
    setLoading(true);
    const body = {
      username,
      password,
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    try {
      let result = await fetch(`${baseURL}/adminlogin`, options);
      result = await result.json();
      if (result.code) {
        setLoading(false);
        checkAdminRole(true);
        navigate("/adminhome");
        return;
      }
      setLoading(false);
      handleSnackbar(true);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }

    return;
  };

  const handleSnackbar = (value) => {
    setState({ ...state, isOpen: value });
  };

  return (
      <Box sx={{ minHeight: "100vh", backgroundColor: "#eef3f8", position: "relative", overflow: "hidden" }}>
    {/* Background shape (top right curve) */}
         <Box
           sx={{
             position: "absolute",
             top: "-120px",
             right: "-120px",
             width: "420px",
             height: "420px",
             backgroundColor: "#dfe7ef",
             borderRadius: "50%",
             zIndex: 0
           }}
         />
       <AdminNavbar isLoggedIn = {sessionStorage.getItem('adminlogin')}/>
         
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={isOpen}
          autoHideDuration={4000}
          onClose={() => handleSnackbar(false)}
        >
          <Alert
            severity="error"
            sx={{
              width: "100%",
              color: "red",
              fontSize: "12px",
              backgroundColor: "#fff",
            }}
          >
            Wrong Username or Password! Please Enter Correct Credentials.
          </Alert>
        </Snackbar>
       

        <br />
       
         <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  mt: 6,
                  position: "relative",
                  zIndex: 2
                }}
              >
               {/* Logo */}
                     <img
                       src={selexsuite}
                       alt="logo"
                       style={{ width: 240, marginBottom: 10 }}
                     />
             
                     {/* Title */}
                     <Typography sx={{ fontSize: 30, mb: 3, color: "#2d2d2d", fontWeight: 500 }}>
                       Admin Login
                     </Typography>
                      <Box
                               sx={{
                                 width: 420,
                                 background: "#ffffff",
                                 borderRadius: "14px",
                                 padding: "52px",
                                 boxShadow: "0 12px 35px rgba(0,0,0,0.12)",
                               }}
                             >
                               {/* Email */}
                                        <Typography sx={{ fontSize: 12, mb: 1, color: "#6b7280", letterSpacing: "1px" }}>
                                          EMAIL OR USERNAME
                                        </Typography>
                              
                                        <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #d1d5db", mb: 3,mt:2 }}>
                                          <PersonOutlineIcon sx={{ fontSize: 18, color: "#9ca3af", mr: 1 }} />
                                          <TextField
                                            fullWidth
                                            variant="standard"
                                            placeholder="admin@selexsuite.com"
                                            onChange={(e) => setUsername(e.target.value)}
                                            InputProps={{ disableUnderline: true }}
                                            inputProps={{ style: { fontSize: 16 } }}
                              
                                          />
                                        </Box>
                                        
                                                                                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <Typography sx={{ fontSize: 12, color: "#6b7280", letterSpacing: "1px" }}>
                                                      PASSWORD
                                                    </Typography>
                                                    </Box>
                                           {/* Password */}
                                                    <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #d1d5db", mb: 4 ,mt:2}}>
                                                      <LockOutlinedIcon sx={{ fontSize: 18, color: "#9ca3af", mr: 1 }} />
                                                      <TextField
                                                        fullWidth
                                                        type={showPassword ? "text" : "password"}
                                                        variant="standard"
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        onKeyPress={(e) => e.key === "Enter" && handleAuth()}
                                                        InputProps={{ disableUnderline: true }}
                                                                      inputProps={{ style: { fontSize: 16 } }}
                                          
                                                      />
                                                      <VisibilityOutlinedIcon
                                                        sx={{ fontSize: 18, color: "#9ca3af", cursor: "pointer" }}
                                                        onClick={() => setShowPassword(!showPassword)}
                                                      />
                                                    </Box>
                                                     {/* Button */}
                                                              <Button
                                                                fullWidth
                                                                onClick={handleAuth}
                                                                sx={{
                                                                  height: 48,
                                                                  borderRadius: "8px",
                                                                  background: "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
                                                                  color: "#fff",
                                                                  fontWeight: 600,
                                                                  letterSpacing: "1px",
                                                                  textTransform: "uppercase",
                                                                  boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
                                                                  ":hover": {
                                                                    background: "linear-gradient(90deg, #095c9c 0%, #1f8bc7 100%)",
                                                                  },
                                                                }}
                                                              >
                                                                {loading ? (
                                                                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                                                                ) : (
                                                                  "Login"
                                                                )}
                                                              </Button>
                              

                             </Box>
           

           

          
          
        </Box>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} component={Paper} elevation={10}>
            <div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "white",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  component="div"
                  sx={{ display: "flex", marginLeft: "1%", marginTop: 0 }}
                >
                  <img
                    style={{ height: "75px", width: "230px", marginTop: "0px" }}
                    src={optimizelogo}
                  />
                </Box>

                <Button
                  onClick={handleClose}
                  sx={{
                    display: "inline-flex",
                    color: "black",
                    fontSize: "16px",
                  }}
                >
                  <CloseIcon sx={{ fontSize: "18px" }} />
                </Button>
              </Box>
            </div>

            <div>
              <br />
              <Typography
                variant="h3"
                sx={{
                  textAlign: "center",
                  fontStyle: "bold",
                  marginTop: "0px",
                }}
              >
                SelexMB™
              </Typography>
              <br />
              <Typography
                variant="h3"
                sx={{ textAlign: "center", fontStyle: "bold" }}
              >
                Industrial AI & Domain Expertise Combine to Optimize Assets
              </Typography>
              <br />
              <Typography variant="h4" sx={{ marginTop: "15px" }}>
                <b>Introduction</b>
              </Typography>
              <br />
              <Typography sx={{ fontSize: 16 }}>
                SelexSuite Solutions has created a method for integrating
                the MLOps (Machine Learning Operations) and ANN concept with
                domain knowledge resulting in a SaaS (Software as a Service)
                application with capabilities to:
              </Typography>
              <br />
              <ol>
                <li style={{ fontSize: 16 }}>Import the field data.</li>
                <li style={{ fontSize: 16 }}>
                  Define the KPI (Key Performance Indicator).
                </li>
                <li style={{ fontSize: 16 }}>Clean the Data.</li>
                <li style={{ fontSize: 16 }}>Build AI Model.</li>
                <li style={{ fontSize: 16 }}>
                  Validate Machine Learning Model.
                </li>
                <li style={{ fontSize: 16 }}>
                  Deploy the Model for Industrial applications and usage.
                </li>
              </ol>
              <br />
              <br />
              <Typography variant="h4">
                <b>Industrial Maturity Overview</b>
              </Typography>
              <br />
              <Typography sx={{ fontSize: 16 }}>
                Industrial Machine Learning Solution can have hundreds of
                functions and the most prominent use for the energy sector is
                applying artificial intelligence to collate and progress data
                for managers to make efficient and informed decisions. To make
                right full-scale transition towards industrial ML application,
                it is very important to understand the maturity level of the
                entity domain to this challenge. Applications with embedded
                industrial Machine Learning will have the capabilities to
                deliver the value of data science methods in existing workflows
                and industrial operation. This enables companies to:
              </Typography>
              <br />
              <br />
              <ul>
                <li style={{ fontSize: 16 }}>
                  Lower the barriers to ML adoption through targeted
                  applications.
                </li>
                <li style={{ fontSize: 16 }}>
                  Overcome the lack of data science and ML skills.
                </li>
              </ul>
              <br />
              <Typography variant="h4">
                <b>SelexMB™ Business Case</b>
              </Typography>
              <br />
              <Typography sx={{ color: "blue", fontSize: 16 }}>
                Business Case: Crude Distillation Column Performance Assessment
              </Typography>
              <br />
              <img
                src={first}
                style={{
                  height: "380px",
                  width: "900px",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
              <br />
              <br />
              <Typography sx={{ fontSize: 16 }}>
                Defining the KPIs (Key Performance Indicators) is a key
                cornerstone to develop a powerful ML model to which all
                dependent variables to be featured and predicted.
              </Typography>
              <br />
              <br />
              <img
                src={second}
                style={{
                  height: "380px",
                  width: "900px",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
              <br />
              <br />
              <Typography sx={{ fontSize: 16 }}>
                Following the completion of data cleaning, the user can identify
                the training/testing split using the recommended practices of
                70/30, 60/40 and 80/20 along with the suitable algorithm to
                complete the prediction process.
              </Typography>
              <br />
              <br />
              <img
                src={third}
                style={{
                  height: "380px",
                  width: "900px",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
              <br />
              <br />
              <Typography sx={{ fontSize: 16 }}>
                Model validation is an assurance stage where user can simply
                adjudge the adequacy of his model based upon the results of R²
                (measurement of accuracy) and Q² (measurement of
                predictability).
              </Typography>
              <br />
              <br />
              <img
                src={fourth}
                style={{
                  height: "380px",
                  width: "900px",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
              <br />
              <br />
              <Typography sx={{ fontSize: 16 }}>
                Once the R² and Q² values are accepted, the ML model can be
                deployed to support business decisions
              </Typography>
              <br />
              <br />
              <Typography variant="h4">
                <b>SelexMB™ Business Advantages</b>
              </Typography>
              <br />
              <Typography sx={{ color: "blue", fontSize: 16 }}>
                Solve More Complex Problems:
              </Typography>
              <Typography sx={{ fontSize: 16 }}>
                {" "}
                Address problems that cannot be easily solved with first
                principles models alone.
              </Typography>
              <br />
              <Typography sx={{ color: "blue", fontSize: 16 }}>
                Build Better Models Faster:
              </Typography>
              <Typography sx={{ fontSize: 16 }}>
                {" "}
                Empower engineers of all skill levels with Industrial AI to
                quickly build and deploy accurate models for digital twins,
                refinery planning using SelexMB™.
              </Typography>
              <br />
              <Typography sx={{ color: "blue", fontSize: 16 }}>
                Sustain Accurate Models Longer:
              </Typography>{" "}
              <Typography sx={{ fontSize: 16 }}>
                AI models provide a better representation of the plant, keeping
                the model more relevant over a longer period, reducing the
                effort required to sustain the model.
              </Typography>
            </div>
          </Box>
        </Modal>

        <Modal
          open={openc}
          onClose={handleClosec}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={stylec} component={Paper} elevation={10}>
            <div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "white",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  component="div"
                  sx={{ display: "flex", marginLeft: "1%", marginTop: 0 }}
                >
                  <img
                    style={{ height: "80px", width: "210px", marginTop: "0px" }}
                    src={optimizelogo}
                  />
                </Box>

                <Button
                  onClick={handleClosec}
                  sx={{
                    display: "inline-flex",
                    color: "black",
                    fontSize: "16px",
                  }}
                >
                  <CloseIcon sx={{ fontSize: "20px" }} />
                </Button>
              </Box>
            </div>
            <Box sx={{ padding: 2 }}>
              <Typography sx={{ fontSize: 18 }}>
                                         {" "}
                                         SelexSuite is a unified platform combing an advanced engineering, AI-driven insights, and robust risk management to support operation. SelexMB, SelexSIM and SelexRISK are designed to integrate with Aspen HYSYS to support your workflow. If you are a HYSYS User, and interested to advance your simulation, contact us via
                                           <Typography sx={{ marginTop: 1 ,fontSize: 18,color:Projectcolors.primary}}>business@optimizegs.com</Typography>
                                       </Typography>
              <br />
               <img
                                  style={{ height: "80px", width: "100px", marginTop: "0px" }}
                                  src={Selexlogo}
                                />
                                 <img
                                  style={{ height: "80px", width: "140px", marginTop: "0px" }}
                                  src={selexmathimg}
                                />
                                 <img
                                  style={{ height: "110px", width: "140px", marginTop: "0px" }}
                                  src={Selexrisk}
                                />
            </Box>
          </Box>
        </Modal>
    </Box>
  );
};

export default Admin;
